export enum HeaderTable{
  titleForVehicleTable = 'Vozilo',  
}

export enum HeaderColumns {
  vehicleName = 'Vozilo',  
}

export enum ModalForAddOrUpdateVehicle {
  titleForAddVehicle = 'Dodavanje novog vozila',
  titleForUpdateVehicle = 'Izmena naziva vozila',
  vehicleNameEmpty = 'Potrebno je uneti naziv vozila.',
  vehicleNamePlaceholder = 'Vozilo',
  saveSuccessMessage = 'Novo vozilo je uspešno sačuvan.',
  updateSuccessMessage = 'Naziv vozila je uspešno izmenjen.',
  deleteSuccessMessage = 'Izabrano vozilo je uspešno obrisan.',
}
